import {Component, OnInit} from '@angular/core';
import {
    ObjectBaseModeComponent
} from "../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";


@Component({
    selector: 'ei-import-type-base',
    template: '',
    standalone: false
})
export class EiImportTypeBaseComponent extends ObjectBaseModeComponent implements OnInit {


    navigationItems: NavigationItem[] = [
        {
            label: 'Basiskonfiguration',
            action: 'basicConfig',
            tooltip: 'Basiskonfiguration',
            icon: 'fa-solid fa-sliders',
            toggleable: false,
            default: true
        },
        {
            label: 'Strukturen',
            action: 'structures',
            tooltip: 'Strukturen',
            icon: 'fa-solid fa-sitemap',
            toggleable: false,
            default: false
        },
        {
            label: 'Regeln',
            action: 'rules',
            tooltip: 'Regeln',
            icon: 'fa-solid fa-gavel',
            toggleable: false,
            default: false
        }
    ];


    ngOnInit() {
        super.ngOnInit();
    }


}
